import { useAuthStore } from '@/stores'

/** Assignment-scoped audit portal — for the auditee, not the auditor. */
function requireAuditee(to, from, next) {
  const authStore = useAuthStore()
  if (authStore.isSuperAdmin || authStore.isAuditeeAssignee) return next()
  next('/not-allowed')
}

export default {
  path: '/auditee',
  children: [
    {
      path: 'audits',
      name: 'auditee-audits',
      component: () => import('@/views/dashboard/auditee/audits/index.vue'),
      beforeEnter: requireAuditee,
      meta: {
        title: 'My Audits — ComplyOne',
        pageTitle: 'My Audits',
        auth: true,
        allowAuthenticated: true,
      },
    },
    {
      path: 'audits/:audit_id',
      name: 'auditee-audit-detail',
      component: () => import('@/views/dashboard/auditee/audits/_id.vue'),
      beforeEnter: requireAuditee,
      meta: {
        title: 'Audit Room — ComplyOne',
        pageTitle: 'Audit Room',
        auth: true,
        allowAuthenticated: true,
      },
    },
  ],
}
